import { Time } from './Enumerations';

export class DateTimeUtil {
	static getCurrentDateInISO8601() {
		return new Date().toISOString();
	}

	static isDateValidInISO(dateInISO: string) {
		if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(.[0-9]+)?(Z)/.test(dateInISO)) {
			return false;
		}
		const currentDate = new Date(dateInISO);
		return currentDate instanceof Date && !isNaN(currentDate.getTime());
	}

	static getTimeFromISODate(dateInISO: string) {
		return new Date(dateInISO).getTime();
	}

	static getMillisecondsFromHours(hours: number) {
		return hours * Time.hoursToMilliseconds;
	}

	static getMillisecondsFromMinutes(minutes: number) {
		return minutes * Time.minutesToMilliseconds;
	}
}
